import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Contacts",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.89 17.9c-1.35 2.12-3.63 3.53-6.26 3.66h-.02a7.84 7.84 0 0 1-6.23-3.57l-.02-.03c-2.01.93-3.71 2.22-5.1 3.79v.02c-.38.4-.6.94-.6 1.53 0 .55.2 1.06.53 1.46 2.8 3.23 6.91 5.26 11.49 5.26s8.6-1.99 11.38-5.14v-.02c.38-.41.6-.95.6-1.54s-.22-1.13-.59-1.54a15.2 15.2 0 0 0-5.1-3.82l-.09-.04Zm-6.28 1.65c1.78-.1 3.32-1 4.29-2.35v-.02c1.63-2.18 2.6-4.92 2.6-7.89v-.38.02C23.5 5.1 20.4 2 16.57 2S9.64 5.1 9.64 8.93v.38c0 2.98.98 5.73 2.64 7.95l-.02-.03c1 1.37 2.57 2.26 4.36 2.33h.01Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.57 29.29h-16c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h16C27.46 1.86 29 3.4 29 5.29v20.57c0 1.89-1.54 3.43-3.43 3.43m-16-25.15c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14h-16Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.57 11H5a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M9.57 16.71H5a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M9.57 22.43H5a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M17.75 15.57c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418 1.71 1.71 0 0 0 .002-3.418M14.14 22.43a1.143 1.143 0 0 1-1.02-1.67c.91-1.74 2.68-2.82 4.62-2.82s3.72 1.08 4.62 2.82a1.143 1.143 0 0 1-2.03 1.05c-.51-.98-1.5-1.59-2.6-1.59s-2.08.61-2.6 1.59c-.2.39-.6.62-1.01.62Z"
      })]
    })
  }));
};
ContactsIcon.displayName = 'ContactsIcon';